import script from "./HeadRow.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadRow.vue?vue&type=script&setup=true&lang=js"

import "./HeadRow.vue?vue&type=style&index=0&id=6d8ba6c6&lang=scss"

export default script